import { useLocation, useNavigate } from 'react-router-dom';
import GuichetTable from './GuichetTable';
import NewFile from './NewFile';
import { useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import CaisseTable from './CaisseTable';

const ContenuQm = () => {
    const navigate = useNavigate()
    const location = useLocation();


    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))

    return (
        <div className='containerAA'>
            < CaisseTable />
        </div>
    );
};

export default ContenuQm;